<template>
    <div class="sps-card sps-card--cta" :class="[`is-image-${layout}`, `is-size-${size}`]">
        <div v-if="card.image" class="sps-card__cta-media">
            <img class="sps-card__cta-image" :src="card.image" :style="imageStyle" alt="" />
        </div>
        <div class="sps-card__cta-text">
            <div class="sps-card__title">{{ lc.title }}</div>
            <p v-if="lc.body" class="sps-card__cta-body">{{ lc.body }}</p>
            <a v-if="card.url && lc.buttonText" class="sps-card__cta-button" :href="card.url" :target="card.openInNewTab === false ? '_self' : '_blank'" rel="noopener noreferrer">{{ lc.buttonText }}</a>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { pickLanguageContent } from "../../../../utils/shell/pickLanguageContent";
// Eylem cagrisi karti: kampanya, demo talebi gibi tek hedefe yonlendiren belirgin kart
// Gorsel: ustte bant ya da metnin solunda/saginda; kaplama/sigdirma ve odak noktasi panelden (eski kartlarda alan yok: ustte, orta boy, kaplama)
export default {
    name: "CtaCard",
    props: { card: { type: Object, required: true } },
    computed: {
        ...mapState({ defaultLocale: (s) => s.catalog.defaultLocale }),
        lc() { return pickLanguageContent(this.card.languageContent, this.$i18n.locale, this.defaultLocale) || {}; },
        layout() { return ["left", "right"].includes(this.card.imageLayout) ? this.card.imageLayout : "top"; },
        size() { return ["s", "l"].includes(this.card.imageSize) ? this.card.imageSize : "m"; },
        imageStyle() {
            const p = this.card.imagePosition || {};
            return { objectFit: this.card.imageFit === "contain" ? "contain" : "cover", objectPosition: `${typeof p.x === "number" ? p.x : 50}% ${typeof p.y === "number" ? p.y : 50}%` };
        },
    },
};
</script>
<style lang="scss">
.sps-card--cta { overflow: hidden;
    .sps-card__title { font-size: 15px; }
    .sps-card__cta-image { display: block; width: 100%; height: 100%; }
    .sps-card__cta-text { min-width: 0; }
    // ustte bant: kartin kenarlarina tasar
    &.is-image-top .sps-card__cta-media { width: calc(100% + 32px); height: 150px; margin: -14px -16px 12px; background: var(--sps-border, rgba(15, 23, 42, 0.06)); }
    &.is-image-top.is-size-s .sps-card__cta-media { height: 100px; }
    &.is-image-top.is-size-l .sps-card__cta-media { height: 210px; }
    // yanda: metinle yan yana kare
    &.is-image-left, &.is-image-right { display: flex; align-items: flex-start; gap: 12px; }
    &.is-image-right { flex-direction: row-reverse; }
    &.is-image-left .sps-card__cta-media, &.is-image-right .sps-card__cta-media { flex: none; width: 88px; height: 88px; border-radius: 10px; overflow: hidden; background: var(--sps-border, rgba(15, 23, 42, 0.06)); }
    &.is-size-s.is-image-left .sps-card__cta-media, &.is-size-s.is-image-right .sps-card__cta-media { width: 64px; height: 64px; }
    &.is-size-l.is-image-left .sps-card__cta-media, &.is-size-l.is-image-right .sps-card__cta-media { width: 116px; height: 116px; }
    &.is-image-left .sps-card__cta-text, &.is-image-right .sps-card__cta-text { flex: 1; }
    .sps-card__cta-body { margin: 6px 0 0; font-size: 13px; line-height: 1.45; color: var(--sps-muted, rgba(15, 23, 42, 0.7)); white-space: pre-line; }
    // vue-material'in genel baglanti rengi (.md-theme-default a:not(.md-button)) ezmesin
    a.sps-card__cta-button:not(.md-button) { display: inline-flex; align-items: center; justify-content: center; margin-top: 12px; padding: 9px 16px; border-radius: 10px; background: var(--button-color, #4f46e5); color: var(--button-text-color, #fff); font-size: 13px; font-weight: 600; text-decoration: none; &:hover { color: var(--button-text-color, #fff); filter: brightness(1.06); } }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/shell/cards/CtaCard.vue